<template>
  <div class="leaders-top">
    <div>
      <div v-for="(shelfBook, index) in categories" :key="index">
        <LeadersBook
          :bookList="shelfBook"
          :indexList="index"
          @handleClick="handleClickBook"
        />
      </div>
      <span class="shelf-bar" />
    </div>
  </div>
</template>

<script>
import GetCategory from "@/components/api/fanClub/leaders/leadersTop";
import LeadersBook from "@/components/fanClub/leaders/LeadersBook.vue";
import { mapActions } from "vuex";

export default {
  components: {
    LeadersBook
  },
  data() {
    return {
      categories: []
    };
  },
  methods: {
    ...mapActions("leaders", ["resetMemberList", "resetHeaderImg"]),

    // カテゴリーをクリックした時の関数
    handleClickBook(categoryValue) {
      this.resetMemberList();
      this.resetHeaderImg();
      this.$router.push(`/fanClub/leaders/list/${categoryValue}`);
    }
  },
  async created() {
    try {
      const res = await GetCategory.getCategoryParagraphList();
      this.categories = res;
    } catch (error) {
      console.log("getCategoryParagraphListのerror:", error);
    }
  }
};
</script>

<style lang="css" scoped>
.leaders-top {
  background-image: url("~@/assets/images/fanclub/leaders/bookshelf-bottom.png");
  background-size: contain;
  background-repeat: repeat-y;
  min-height: 100vh;
  min-width: 100%;
}
.shelf-bar {
  height: 20px;
  background-size: contain;
  display: block;
  background-image: url("~@/assets/images/fanclub/leaders/bookshelf-horizon.png");
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/leaders/LeadersTop.vue